import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";

export default function FirstApartament() {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const imageRef = useRef(null);

  const customUrl1 = "15"; // First URL (image)
  const customUrl2 = "15"; // Floor number
  const customUrl3 ="8"; // Floor number
  const vrPath = "vr-15"; // Dynamic VR directory

  // Detect mobile devices
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Close hover effect when clicking outside (only on mobile)
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (imageRef.current && !imageRef.current.contains(event.target)) {
        setIsHovered(false);
        setIsClicked(false);
      }
    };

    if (isMobile && isClicked) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobile, isClicked]);

  const handleClick = () => {
    if (isMobile) {
      if (!isClicked) {
        setIsClicked(true);
        setIsHovered(true);
      } else {
        navigate("/navigate-floor", { state: { customUrl1, customUrl2, vrPath, customUrl3 } });
      }
    } else {
      navigate("/navigate-floor", { state: { customUrl1, customUrl2, vrPath, customUrl3 } });
    }
  };

  return (
    <img 
      ref={imageRef}
      className={`absolute w-[18vw] right-[31.4vw] top-[20.5vw] cursor-pointer transition-opacity duration-100 ${isHovered ? 'opacity-100' : 'opacity-0'}`}
      src="/images/click/clickable-images/Floors/Direct-floors/clickable-floors/EighthFloor/FirstApartament-Green.png"
      alt="First Apartament"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    />
  );
}
